let lastActivity = Date.now()

export const updateActivity = () => {
  lastActivity = Date.now()
}

export const getLastActivity = () => lastActivity

export const startTrackingActivity = () => {
  const events = ['keydown', 'click', 'scroll']
  events.forEach((event) => window.addEventListener(event, updateActivity))
}
